export const isInstagramBrowser = (): boolean => {
  // For reference on what Instagram's in-app browser uses for user agent:
  // https://whatmyuseragent.com/apps/instagram-app. For some reason it doesn't
  // seem to include iOS but I just checked the user agent w/in my Instagram app
  // on iOS and it also had "Instagram" in it.
  return /instagram/i.test(navigator.userAgent);
};

export const isTikTokBrowser = (): boolean => {
  // For reference on what TikTok's in-app browser uses for user agent:
  // https://whatmyuseragent.com/apps/tiktok
  return /tiktok|bytedance|bytelocale/i.test(navigator.userAgent);
};
